var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconMusic = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-2.167 -2.167)" },
                React.createElement("path", { d: "M13.9,23.7V9.6l13-2.2v14.1" }),
                React.createElement("path", { d: "M13.9,23.7c0,1.8-1.5,3.2-3.2,3.2s-3.2-1.5-3.2-3.2s1.5-3.2,3.2-3.2S13.9,21.9,13.9,23.7z" }),
                React.createElement("path", { d: "M26.9,21.5c0,1.8-1.5,3.2-3.2,3.2s-3.2-1.5-3.2-3.2s1.5-3.2,3.2-3.2S26.9,19.7,26.9,21.5z" })))));
});
export default IconMusic;
//# sourceMappingURL=IconMusic.js.map